/* x-lightbox.js — Galerie-Lightbox auf <dialog>-Basis: exakt angeklicktes Bild,
   Wischen, Pfeiltasten, Vor/Zurueck, Zaehler, Escape, Fokus bleibt im Dialog
   (showModal) und geht danach auf das angeklickte Bild zurueck; Body-Scroll
   gesperrt; Bilder werden erst beim Anzeigen geladen. */
(() => {
  const dlg = document.querySelector('[data-x-lightbox]');
  if (!dlg || typeof dlg.showModal !== 'function') return;
  const bilder = Array.from(dlg.querySelectorAll('[data-x-lightbox-bild]'));
  const zaehler = dlg.querySelector('[data-x-lightbox-zaehler]');
  const buehne = dlg.querySelector('[data-x-lightbox-buehne]');
  let index = 0;
  let ausloeser = null;

  const lade = (fig) => {
    const img = fig.querySelector('img');
    if (img.dataset.src && !img.getAttribute('src')) img.src = img.dataset.src;
    if (img.dataset.srcset && !img.getAttribute('srcset')) img.srcset = img.dataset.srcset;
  };
  const zeige = (i) => {
    index = (i + bilder.length) % bilder.length;
    bilder.forEach((b, n) => { b.hidden = n !== index; });
    lade(bilder[index]);
    if (bilder[index + 1]) lade(bilder[index + 1]);
    zaehler.textContent = `${index + 1} / ${bilder.length}`;
  };
  const oeffne = (i, knopf) => {
    ausloeser = knopf;
    zeige(i);
    dlg.showModal();
    document.documentElement.classList.add('x-lightbox-offen');
    dlg.querySelector('[data-x-lightbox-schliessen]').focus();
  };
  const schliesse = () => {
    if (dlg.open) dlg.close();
  };
  dlg.addEventListener('close', () => {
    document.documentElement.classList.remove('x-lightbox-offen');
    if (ausloeser) ausloeser.focus();
  });

  document.querySelectorAll('[data-x-lightbox-oeffnen]').forEach((k) => {
    k.addEventListener('click', () => oeffne(Number(k.dataset.xLightboxOeffnen), k));
  });
  dlg.querySelector('[data-x-lightbox-schliessen]').addEventListener('click', schliesse);
  dlg.querySelector('[data-x-lightbox-vor]').addEventListener('click', () => zeige(index + 1));
  dlg.querySelector('[data-x-lightbox-zurueck]').addEventListener('click', () => zeige(index - 1));
  dlg.addEventListener('keydown', (e) => {
    if (e.key === 'ArrowRight') { e.preventDefault(); zeige(index + 1); }
    if (e.key === 'ArrowLeft') { e.preventDefault(); zeige(index - 1); }
  });
  // Klick auf den Hintergrund schliesst
  dlg.addEventListener('click', (e) => { if (e.target === dlg) schliesse(); });

  // Wischen: horizontal nur innerhalb der Buehne, Seite bleibt unberuehrt
  let startX = 0, startY = 0, aktiv = false;
  buehne.addEventListener('touchstart', (e) => { if (e.touches.length !== 1) return; startX = e.touches[0].clientX; startY = e.touches[0].clientY; aktiv = true; }, { passive: true });
  buehne.addEventListener('touchend', (e) => {
    if (!aktiv) return; aktiv = false;
    const dx = e.changedTouches[0].clientX - startX, dy = e.changedTouches[0].clientY - startY;
    if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.5) zeige(dx < 0 ? index + 1 : index - 1);
  }, { passive: true });
  // Doppeltipp/Doppelklick: Bild-Zoom nur innerhalb der Buehne
  buehne.addEventListener('dblclick', (e) => {
    const fig = bilder[index];
    fig.classList.toggle('x-lightbox__bild--zoom');
    const img = fig.querySelector('img');
    if (fig.classList.contains('x-lightbox__bild--zoom')) {
      const r = img.getBoundingClientRect();
      img.style.transformOrigin = `${((e.clientX - r.left) / r.width) * 100}% ${((e.clientY - r.top) / r.height) * 100}%`;
    } else {
      img.style.transformOrigin = '';
    }
  });
})();
